import { NoDataFound } from '@fabric-ui/components';
import TicketNotFound from '@fabric-ui/icons/svg/emptyStates/Ticket not found.svg';
import { refetchingStyle } from '@fabric-ui/theme';
import { Button } from '@mui/material';
import Pluralize from 'pluralize';

export const TicketsNoDataFoundDefault = ({ projDisplayName, isRefetching, clearAllFilters }) => (
  <NoDataFound
    headline={`No ${Pluralize(projDisplayName)} Found`}
    img={TicketNotFound}
    style={isRefetching ? { containerStyle: refetchingStyle } : {}}
    callToAction={
      <>
        Try to <Button onClick={() => clearAllFilters(false, true)}>Clear All filters</Button>
      </>
    }
  />
);
